import { useRecoilState } from "recoil";
import { loginState } from "../stores/loginState";
import { useMutation } from "react-query";
import Swal from "sweetalert2";
import {
  LogenInstance,
} from "./instance";

const useGetNVRLogin = (key) => {
  // NOTE 상태 변수 선언
  const [login, setLogin] = useRecoilState(loginState);
  
  // NOTE 로그인 정보 저장
  const handleLoginSuccess = (data) => {
    let isNvr = "0";
    if(data.data[0].company === "logen" || login.company === "Logen"){
      isNvr = data.data[0].nvr_usable;
    }
    setLogin({
      ...login,
      isLogin: true,
      userId: data.data[0].user_id,
      branchName: data.data[0].bran_exp,
      branchCode: data.data[0].bran_cd,
      saId: data.data[0].sa_id,
      accountId: data.data[0].account_id,
      camUsable: data.data[0].cam_usable,
      camStatus: data.data[0].cam_status,
      company: data.data[0].company.toUpperCase(),
      nvrUsable: isNvr,
    });
  };
  
  // TODO API 성공 시
  const handleSuccess = (data) => {
    if (data.result === "00" || data.result === "77") { // 조회 성공 시
      handleLoginSuccess(data);
      Swal.fire({
        icon: "success",
        title: "NVR에서 로그인시도에\n성공하였습니다.",
        confirmButtonText: "확인",
      });
    } else { // 송장번호 입력 오류
      Swal.fire({
        icon: "error",
        title: "NVR에서 로그인시도를\n실패하였습니다.",
        confirmButtonText: "확인",
      });
    }
  };

  // TODO API 실패 시
  const handleError = (error) => {
    console.log(error);
  };

  // TODO Mutation 옵션 설정
  const mutationOptions = {
    onSuccess: handleSuccess,
    onError: handleError,
  };

  // TODO API 요청 데이터 생성
  const createPostData = () => ({
    api: "autoLogin",
    data : [
      {
        login_key: key
      }
    ]
  });

  // NOTE 회사 별 인스턴스
  const instanceMap = {
    LOGEN: LogenInstance,
  };

  // TODO API 리퀘스트 정보
  const mutationFunction = () => {
    const instance = instanceMap["LOGEN"];
    if (!instance) throw new Error("Invalid company");
    return instance.post("/watcher/sign", createPostData());
  };

  // NOTE 데이터 요청 관리
  return useMutation("getWorkInvoiceList", mutationFunction, mutationOptions);
};

export default useGetNVRLogin;
